import { render } from "./NftConstructorToken.vue?vue&type=template&id=23f8b529"
import script from "./NftConstructorToken.vue?vue&type=script&lang=js"
export * from "./NftConstructorToken.vue?vue&type=script&lang=js"

import "./NftConstructorToken.vue?vue&type=style&index=0&id=23f8b529&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__